<template>
  <section class="section --dark --bottom --top employee-timeline__section w-95">
    <div class="employee-timeline__left">
      <h2 class="title --uppercase" v-reveal>{{ content.title }}</h2>
			<HighlightableText class="description" :text="content.description" />
    </div>
    <div class="employee-timeline__right" id="timeline">
      <div class="employee-timeline__profile" v-reveal>
        <Transition name="fade-custom">
          <Image :source="employee.image" class="employee-timeline__image" :key="currentEmployeeIndex" />
        </Transition>
        <div class="employee-timeline__content">
          <Transition name="fade-custom">
            <div class="employee-timeline__content-container" :key="currentEmployeeIndex">
              <h3 class="title --small">{{ employee.title }}</h3>
              <p class="description">{{ employee.shortDescription }}</p>
              <button class="employee-timeline__button" @click="$store.dispatch('updateEmployee', employee)">
                <span class="employee-timeline__button-icon">
                  <Icon id="plus" />
                </span>
                <span>{{ employee.readMore }}</span>
              </button>
            </div>
          </Transition>
        </div>
      </div>
      <div class="employee-timeline__bottom" v-reveal>
        <div :class="['employee-timeline__event-list', { '--laptop': i === 2 }]" v-for="i in 2" :key="`timeline-${i}`">
          <div v-for="event in employee.timeline" class="employee-timeline__event" :key="event.flexKey">
            <p class="title --small">{{ event.date }}</p>
            <p>{{ event.description }}</p>
          </div>
        </div>
        <ButtonControls :current="currentEmployeeIndex" :max="content.items.length - 1"
          @increase="currentEmployeeIndex += 1" @decrease="currentEmployeeIndex -= 1"
          class="employee-timeline__controls" />
        <div class="employee-timeline__shadow" />
      </div>
    </div>
  </section>
</template>

<script>
import { HasContentMixin } from '@/mixins'
import { ButtonControls, HighlightableText } from '@/components/blocks'
import { Icon, Image } from '@/components/global'

export default {
  name: 'EmployeeTimelineSection',
  mixins: [HasContentMixin],
  components: { ButtonControls, HighlightableText, Icon, Image },
  data() {
    return {
      currentEmployeeIndex: 0
    }
  },
  computed: {
    employee() {
      return this.content.items[this.currentEmployeeIndex]
    }
  },
  watch: {
    'currentEmployeeIndex'() {
      this.$router.push({ ...this.$route, hash: '#timeline' })
    }
  }
}
</script>